/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Closing_BodyInputs */



/**
* | output |
* | --- |
* | "Sign in with Discord and add the bot. Analytics and levelling both come with the free plan." |
*
* @param {Products_Closing_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_closing_body = /** @type {((inputs?: Products_Closing_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Closing_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Войдите через Discord и добавьте бота. Аналитика и уровни есть уже на тарифе Free.")
	return /** @type {LocalizedString} */ ("Sign in with Discord and add the bot. Analytics and levelling both come with the free plan.")
});